export default {"src":"/_next/static/media/butternut-squash.1477aa54.svg","height":38,"width":72,"blurWidth":0,"blurHeight":0};